import CalendarArrowLeftIcon from '@/assets/svg/boutique-calendar/calendar-arrow-left.svg';
import CalendarArrowRightIcon from '@/assets/svg/boutique-calendar/calendar-arrow-right.svg';
import NotebookDecoration from '@/assets/svg/boutique-calendar/decoration-notebook.svg';
import BooksDecoration from '@/assets/svg/boutique-calendar/decoration-books.svg';
import PencilDecoration from '@/assets/svg/boutique-calendar/decoration-pencil.svg';
import PlantDecoration from '@/assets/svg/boutique-calendar/decoration-plant.svg';
import DetailCalendarIcon from '@/assets/svg/boutique-calendar/detail-calendar.svg';
import DetailClockIcon from '@/assets/svg/boutique-calendar/detail-clock.svg';
import DetailVideoIcon from '@/assets/svg/boutique-calendar/detail-video.svg';
import DetailLinkIcon from '@/assets/svg/boutique-calendar/detail-link.svg';
import DetailCloseIcon from '@/assets/svg/boutique-calendar/detail-close.svg';

export const BoutiqueCalendarEventType = {
	GROUP_LIVE_LESSON: 'GROUP_LIVE_LESSON',
	STUDY_TOGETHER: 'STUDY_TOGETHER',
	PRACTICE_CLUB: 'PRACTICE_CLUB',
	MOTIVATION: 'MOTIVATION',
	PRIVATE_LESSON: 'PRIVATE_LESSON',
	TUTORING: 'TUTORING',
	PUBLISHED: 'PUBLISHED',
	DRAFT: 'DRAFT',
	CANCELLED: 'CANCELLED',
	ARCHIVED: 'ARCHIVED'
} as const;

export const BoutiqueCalendarEventConfig: Record<string, { label: string; variant: string; decorationUrl?: string }> = {
	[BoutiqueCalendarEventType.GROUP_LIVE_LESSON]: { label: 'Grup Canlı Dersi', variant: 'blue', decorationUrl: BooksDecoration },
	[BoutiqueCalendarEventType.STUDY_TOGETHER]: { label: 'Birlikte Çalışma', variant: 'green', decorationUrl: PencilDecoration },
	[BoutiqueCalendarEventType.PRACTICE_CLUB]: { label: 'Deneme Kulubü', variant: 'amber', decorationUrl: PlantDecoration },
	[BoutiqueCalendarEventType.MOTIVATION]: { label: 'Motivasyon', variant: 'violet', decorationUrl: NotebookDecoration },
	[BoutiqueCalendarEventType.PRIVATE_LESSON]: { label: 'Özel Ders', variant: 'violet', decorationUrl: NotebookDecoration },
	[BoutiqueCalendarEventType.TUTORING]: { label: 'Etüt', variant: 'green', decorationUrl: NotebookDecoration },
	[BoutiqueCalendarEventType.PUBLISHED]: { label: 'Yayında', variant: 'blue', decorationUrl: BooksDecoration },
	[BoutiqueCalendarEventType.DRAFT]: { label: 'Taslak', variant: 'amber', decorationUrl: PlantDecoration },
	[BoutiqueCalendarEventType.CANCELLED]: { label: 'İptal Edildi', variant: 'violet', decorationUrl: NotebookDecoration },
	[BoutiqueCalendarEventType.ARCHIVED]: { label: 'Arşivlendi', variant: 'green', decorationUrl: PencilDecoration }
};

export const BoutiqueCalendarArrowIcon = {
	previous: CalendarArrowLeftIcon,
	next: CalendarArrowRightIcon
} as const;

export const BoutiqueCalendarDayCount = 7;
export const BoutiqueCalendarAutoScrollOffset = 24;
export const BoutiqueCalendarAutoScrollDuration = 400;
export const BoutiqueCalendarWeekStep = 1;

export const BoutiqueCalendarDefaultStartHour = 9;
export const BoutiqueCalendarDefaultEndHour = 24;

export const BoutiqueCalendarDayNameList = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'] as const;
export const BoutiqueCalendarShortDayNameList = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cts', 'Paz'] as const;

export const BoutiqueCalendarDateFormat = {
	key: 'YYYY-MM-DD',
	dayNumber: 'D',
	dayWithMonth: 'D MMMM',
	dayWithMonthAndYear: 'D MMMM YYYY',
	dayNameWithMonth: 'dddd, D MMMM',
	time: 'HH:mm'
} as const;

export const BoutiqueCalendarTimeSeparator = ' – ';
export const BoutiqueCalendarRangeSeparator = ' - ';
export const BoutiqueCalendarLocale = 'tr';

export const BoutiqueCalendarTexts = {
	title: 'Butik Çalışma Takvimin',
	todayButton: 'Bugün',
	previousWeek: 'Önceki hafta',
	nextWeek: 'Sonraki hafta'
} as const;

export const BoutiqueEventTagVariant = {
	BRANCH: 'branch',
	EVENT_TYPE: 'event-type',
	EXAM_TYPE: 'exam-type'
} as const;

export const BoutiqueEventPopoverIcon = {
	calendar: DetailCalendarIcon,
	clock: DetailClockIcon,
	video: DetailVideoIcon,
	link: DetailLinkIcon,
	close: DetailCloseIcon
} as const;

export const BoutiqueEventPopoverTexts = {
	description: 'Açıklama',
	joinLink: 'Katılım Linki',
	copyJoinLink: 'Katılım linkini kopyala',
	joinLinkCopied: 'Katılım linki kopyalandı.',
	tags: 'Etiketler',
	participants: 'Katılımcılar',
	participantCountSuffix: 'katılımcı',
	groupsAndStudents: 'Gruplar ve Öğrenciler',
	groupCountSuffix: 'grup',
	studentCountSuffix: 'öğrenci',
	ungroupedStudents: 'Diğer Öğrenciler',
	expandSection: 'Bölümü genişlet',
	collapseSection: 'Bölümü daralt',
	expandGroup: 'Öğrencileri göster',
	collapseGroup: 'Öğrencileri gizle',
	joinButton: 'Katıl',
	editButton: 'Düzenle',
	closeButton: 'Kapat'
} as const;

export const BoutiqueEventPopoverVisibleParticipantCount = 4;
export const BoutiqueEventPopoverVisibleGroupAvatarCount = 4;
export const BoutiqueEventPopoverScrollGroupCount = 2;
export const BoutiqueEventPopoverSummarySeparator = ' · ';
export const BoutiqueEventPopoverUngroupedGroupId = null;
export const BoutiqueEventPopoverCloseKey = 'Escape';

export const BoutiqueEventPopoverGap = 12;
export const BoutiqueEventPopoverViewportPadding = 16;
export const BoutiqueEventPopoverArrowInset = 28;

export const BoutiqueEventPopoverPlacement = {
	RIGHT: 'right',
	LEFT: 'left'
} as const;
